// Models
import { Transaction } from 'models/Transaction'

// Redux services
import { createResourceTrackingCode } from 'redux/services/resourceTrackingCode'

// Local
import { RootState, TypedDispatch } from 'redux/store'
import { FinalizeOrderArgs } from '../types'

/**
 * Creates resource tracking codes.
 * @param transaction - Transaction details
 */
const saveResourceTrackingCodes = async (
  dispatch: TypedDispatch<RootState>,
  { id: transactionId }: Transaction,
  { c_src, c_src2, referrer }: FinalizeOrderArgs,
): Promise<void> => {
  // Change any to actual types
  if (c_src) {
    await dispatch(
      createResourceTrackingCode.initiate({
        c_src,
        ...(c_src2 ? { c_src2 } : {}),
        referrer,
        event_type: 'create',
        resourceType: 'transactions',
        resourceId: String(transactionId),
      }),
    ).unwrap()
  }
}

export default saveResourceTrackingCodes
